export enum VisibleDays {
    All = 0,
    Incorrect = 2 /* Don't change this, it's passed to the API to generate excel report. */
}
